import ApiService from '@/services/ApiService';

const NO_REDIRECT = true;

const isLostSession = (error) =>
  (error?.status === 401 || error?.status === 403) && !error?.response?.code;

async function postSharkTankAction(statusId, contactId, action) {
  try {
    return await ApiService.post(
      `/api3/leads/shark-tank/${statusId}/${action}/`,
      { contact_id: contactId },
      undefined,
      false,
      NO_REDIRECT
    );
  } catch (error) {
    if (isLostSession(error)) ApiService.handleUnauthorizedRedirect(false);
    throw error;
  }
}

class LeadsService {
  static async getLeads(query) {
    const composedURL = `/api3/leads/table${query}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getLeadCounts(query) {
    const composedURL = `/api3/leads/counts${query}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async setLeadStatus(data) {
    const composedURL = '/api3/contacts/set_lead_status';
    const response = await ApiService.post(composedURL, data);
    return response;
  }

  static async loadMoreLeads(data) {
    const composedURL = `/api3/leads/status${data.query}`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async setLeadComment(data) {
    const composedURL = '/api3/contacts/set_lead_comment';
    const response = await ApiService.post(composedURL, data);
    return response;
  }

  static async getLeadsStatus() {
    const composedURL = '/api3/contact/leads_status';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getAgentsForLeads() {
    const composedURL = '/api3/agent/?only_actives=true';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async reassignLeads(data) {
    const composedURL = '/api3/contacts/set_lead_agent';
    const response = await ApiService.post(composedURL, data);
    return response;
  }

  static async changeViewLeadsPreferences(data) {
    const composedURL = '/api3/leads/display_preference';
    const response = await ApiService.post(composedURL, data);
    return response;
  }

  static async getLeadsTags() {
    const composedURL = '/api3/leads/tags_for_closing_excuse';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async getClosingExcuses() {
    const composedURL = '/api3/leads/closing_excuses';
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async createClosingExcuse(body) {
    return ApiService.post('/api3/leads/closing_excuses', body);
  }

  static async replaceClosingExcuse(excuseId, body) {
    return ApiService.put(`/api3/leads/closing_excuses/${excuseId}`, body);
  }

  static async qualifyClosingExcuse(excuseId, qualification) {
    return ApiService.patch(`/api3/leads/closing_excuses/${excuseId}`, {
      qualification,
    });
  }

  static async deleteClosingExcuse(excuseId) {
    return ApiService.delete(`/api3/leads/closing_excuses/${excuseId}`);
  }

  static async getSharkTankQuota(statusId) {
    const composedURL = `/api3/leads/shark-tank/${statusId}/quota/`;
    const response = await ApiService.get(composedURL);
    return response;
  }

  static async claimSharkTankContact(statusId, contactId) {
    return postSharkTankAction(statusId, contactId, 'claim');
  }

  static async recoverSharkTankContact(statusId, contactId) {
    return postSharkTankAction(statusId, contactId, 'recover');
  }

  static async getContactTags(contactId) {
    return ApiService.get(
      `/api3/contact/${contactId}/tags/`,
      undefined,
      false,
      true
    );
  }

  static async updateContactTags(contactId, tagIds) {
    return ApiService.put(`/api3/contact/${contactId}/tags/`, {
      tag_list: tagIds,
    });
  }

  static async closeLeads(payload) {
    const composedURL = '/api3/contacts/close_leads';
    const response = await ApiService.post(composedURL, payload);
    return response;
  }
}

export default LeadsService;
